module.exports = __webpack_public_path__ + "assets/img/img-success.2979afff.png";